import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ThemeService } from 'src/app/_services/theme.service';

@Component({
  selector: 'tangram-content-completion',
  templateUrl: './content-completion.component.html',
  styleUrls: ['./content-completion.component.scss']
})
export class ContentCompletionComponent implements OnInit, OnDestroy {
  @Input() contentProcessed: any;
  @Input() isDashboard: boolean;

  // Progress-ring colour follows the active theme's primary. Falls back to
  // the original pink when no theme var is set (i.e. base dark mode).
  outerStrokeColor = '#D54ED2';
  private themeSub: Subscription;

  constructor(private themeService: ThemeService) { }

  ngOnInit() {
    this.resolveStrokeColor();
    this.themeSub = this.themeService.effective$.subscribe(() => this.resolveStrokeColor());
  }

  ngOnDestroy(): void {
    if (this.themeSub) {
      this.themeSub.unsubscribe();
    }
  }

  private resolveStrokeColor(): void {
    const primary = getComputedStyle(document.documentElement)
      .getPropertyValue('--tangram-primary').trim();
    this.outerStrokeColor = primary || '#D54ED2';
  }
}
